import { render, staticRenderFns } from "./Forgot_pass.vue?vue&type=template&id=1e6b1f18&scoped=true"
import script from "./Forgot_pass.vue?vue&type=script&lang=js"
export * from "./Forgot_pass.vue?vue&type=script&lang=js"
import style0 from "./Forgot_pass.vue?vue&type=style&index=0&id=1e6b1f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6b1f18",
  null
  
)

export default component.exports